import React, { ChangeEvent } from "react";

import { Disclosure } from "@headlessui/react";
import { ChevronRightIcon } from "@heroicons/react/outline";
import ServiceMenu from "./ServiceMenu";
import { isMobile as isMobileSize } from "@/utils/media-query";
import { ServiceReserveStatus } from "@/apis/clients";

interface ServiceMenuData {
  name?: string;
  description?: string;
  price?: number;
  options?: ServiceMenuOptionDetail[];
}

interface ServiceMenuOptionDetail {
  name: string;
  description: string;
  price: number;
  time: number;
}
type Props = {
  menus: ServiceMenuData[];
  options: ServiceMenuOptionDetail[];
  type?: string;
  summaryPrice?: string;
  isFee?: boolean;
  serviceReserveStatus?: ServiceReserveStatus;
  isCouponVisible?: boolean;
  isCouponApplied?: boolean;
  couponCode?: string;
  subtotalPrice?: string;
  couponDiscountPrice?: string;
  couponLabel?: string;
  isCouponLoading?: boolean;
  couponErrorMessage?: string;
  onCouponChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onCouponApply?: () => void | Promise<void>;
  onCouponCancel?: () => void | Promise<void>;
};

export default function ServiceMenuResponsive(props: Props) {
  const isMobile = isMobileSize();
  if (isMobile) {
    return (
      <div className="mx-auto w-full max-w-md rounded-2xl bg-white">
        <Disclosure>
          {({ open }) => (
            <div className="border border-[#3ABCA8] rounded">
              <Disclosure.Button className="flex !h-[56px] w-full gap-x-2 justify-center items-center font-medium text-[#3ABCA8] text-center">
                <ChevronRightIcon
                  className={`${open ? "rotate-90 transform" : ""
                    } h-4 w-4 text-[#3ABCA8]`}
                />{" "}
                <span className="font-bold text-base leading-6">
                  お申し込み内容をすべて表示
                </span>
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pb-2 pt-4">
                <ServiceMenu {...props} />
              </Disclosure.Panel>
            </div>
          )}
        </Disclosure>
      </div>
    );
  }
  return <ServiceMenu {...props} />;
}
